import React from 'react'
import omit from 'lodash/fp/omit'

import FormControl from '../FormControl'
import CheckboxIcon from './CheckboxIcon'
import CheckboxInput from './CheckboxInput'

function Checkbox({
  value,
  checked = value === true,
  error,
  ...props
}) {
  return (
    <FormControl>
      {({ focused, getInputProps }) => (
        <CheckboxIcon checked={checked} focused={focused} error={error}>
          <CheckboxInput
            {...omit(['onFilled', 'onEmpty'], getInputProps(props))}
            checked={checked}
          />
        </CheckboxIcon>
      )}
    </FormControl>
  )
}

export default Checkbox
